// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function bulkReason_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var reason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "reason"), null));
    if (reason.TAG === /* Ok */0) {
      var reason_enum = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "reason_enum"), null));
      if (reason_enum.TAG === /* Ok */0) {
        var is_bulk_txn_allowed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_bulk_txn_allowed"), null));
        if (is_bulk_txn_allowed.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    reason: reason._0,
                    reason_enum: reason_enum._0,
                    is_bulk_txn_allowed: is_bulk_txn_allowed._0
                  }
                };
        }
        var e = is_bulk_txn_allowed._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_bulk_txn_allowed" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = reason_enum._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".reason_enum" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = reason._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".reason" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function credit_decode(v) {
  return Decco.listFromJson(bulkReason_decode, v);
}

function debit_decode(v) {
  return Decco.listFromJson(bulkReason_decode, v);
}

function reason_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var credit = Decco.listFromJson(bulkReason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credit"), null));
  if (credit.TAG === /* Ok */0) {
    var debit = Decco.listFromJson(bulkReason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "debit"), null));
    if (debit.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                credit: credit._0,
                debit: debit._0
              }
            };
    }
    var e = debit._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".debit" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = credit._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".credit" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function res_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var reason = reason_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "reason"), null));
  if (reason.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              reason: reason._0
            }
          };
  }
  var e = reason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".reason" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  bulkReason_decode ,
  credit_decode ,
  debit_decode ,
  reason_decode ,
  res_decode ,
  
}
/* No side effect */
